module.exports = __webpack_public_path__ + "static/media/FoodIconsCover.5f0fdfc4.jpg";